import React, {useEffect, useState} from 'react';
import '../scss/components/Profile.scss';
import { Link, useParams } from 'react-router-dom';
import { ApiResponseType } from '../features/api/types.ts';
import { useAuthlessApi } from '../features/auth/hooks/use-authless-api.ts';
import Card from '../components/Structure/Card.tsx';

export default function AccountActivateToken() {
    const [isLoading, setIsLoading] = useState(true);
    const { token } = useParams();
    
    const { activateAccount } = useAuthlessApi();

    const [responseMessage, setResponseMessage] = useState<String|Array<String>>('');
    const [responseMessageClass, setResponseMessageClass] = useState('');

    useEffect(() => {
        activateAccount(token).then(data => {
            setResponseMessage(data.payload.error);
            if (data.type === ApiResponseType.OK) {
                setResponseMessageClass('success');
            } else {
                setResponseMessageClass('error');
            }
            setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
        })
    },[]);

    if (isLoading) {
        return (
            <Card
                p={'var(--spacing-2xl)'}
                gap={'var(--spacing-xl)'}
            >
                <div className="loader inline"></div>
            </Card>
        )
    }

    return (
        <Card
            p={'var(--spacing-2xl)'}
            gap={'var(--spacing-xl)'}
            className='wide'
        >
            <div className={`message${responseMessageClass ? ' ' + responseMessageClass : ''}`} role="alert">
                <span>
                    {responseMessageClass !== 'success' ? responseMessage : 'Account erfolgreich aktiviert. Sie können sich jetzt einloggen.'}
                </span>
            </div>
            { responseMessageClass === 'success' && (                
                <Link className="button button-primary float-center" to={`/`}>Login</Link>
            ) }
        </Card>
    )
}